import { defineMessages } from 'react-intl';

export default defineMessages({
    certificationYes: {
        id: 'policy.sw.directives.employee-info.Yes',
        defaultMessage: 'Yes'
    },
    certificationNo: {
        id: 'policy.sw.directives.employee-info.No',
        defaultMessage: 'No'
    }
});
